import { useTranslation } from 'react-i18next';
import type { ExamType } from '@proref/types';
import { RouteTabs } from '../shared/RouteTabs';

interface ExamTabsProps {
  examId: string;
}

// /admin/exams is itself two RouteTabs-linked tabs (Rule tests / Video tests, ExamsPage) rather
// than one combined list — so "back to all exams" from inside one exam (the editor's All-exams
// link + Done button, the results page's All-exams link) must return to the tab that actually
// shows this exam, or a video test would drop the admin onto the Rule tests tab. Shared here
// since every page that links "back out" of an exam already imports ExamTabs from this module.
export function examsListPath(type: ExamType): string {
  return type === 'video_clip_exam' ? '/admin/exams/video-tests' : '/admin/exams';
}

// The two halves of working on one exam: authoring it, and reading how the cohort did.
//
// They stay SEPARATE ROUTES rather than one page with local tab state — a federation admin sends
// "look at these results" links to colleagues, and admin state that can't be linked to is a
// recurring annoyance. The shared RouteTabs derives the active tab from the URL, so a deep link
// opens on the right tab and the browser's back button behaves.
export function ExamTabs({ examId }: ExamTabsProps) {
  const { t } = useTranslation();
  return (
    <RouteTabs
      tabs={[
        { to: `/admin/exams/${examId}/edit`, label: t('admin.exams.tabs.questions') },
        { to: `/admin/exams/${examId}/results`, label: t('admin.exams.list.analytics') },
      ]}
    />
  );
}
